import React from 'react';
import Accordion from '../Accordion';
import './Faq.css';

const Faq = () => {
  const faqItems = [
    {
      title: "Какие документы необходимы для заселения иностранных граждан?",
      content: "Необходимо на каждого Гостя: Действующий паспорт и Миграционная карта (не всегда обязательно)."
    },
    {
      title: "Как вы сможете помочь с миграционным учетом?",
      content: "Мы поставим Вас на миграционный учет в соответствии с законодательством РФ, в данном случаем мы будем действовать в полномочиях принимающей стороны и владельцев жилья."
    },
    {
      title: "Есть ли парковка у вашей гостиницы",
      content: "Да, вы сможете оставлять автомобиль на открытой парковке, отгороженной воротами. Кроме того, для этих целей на территории есть гараж на несколько машиномест."
    },
    {
      title: 'Есть ли беспроводной интернет Wi-Fi в "Белой"?',
      content: "Да, стабильный сигнал внутри и на придомовой территории гостиницы."
    }
  ];

  return (
    <section className="faq" id="LayoutGrid1">
      <div className="faq-overlay"></div>
      <div className="container">
        <div className="faq-content">
          <div className="faq-header">
            <h2 className="faq-title">ВАШИ ВОПРОСЫ И ОТВЕТЫ</h2>
            <p className="faq-subtitle">
              FAQ по частым вопросам от желающих поселиться
            </p>
          </div>
          
          <Accordion items={faqItems} className="faq-accordion" />
        </div>
      </div>
    </section>
  );
};

export default Faq;